import { useNavigate } from "@tanstack/react-router";
import { Loader2, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRestartOnboarding } from "@/lib/hooks/useOnboarding";

/** "Refazer configuracao": reabre o wizard de 5 passos no Dashboard. */
export function RestartOnboardingCard(): JSX.Element {
  const navigate = useNavigate();
  const { restart, isPending, isError } = useRestartOnboarding();

  const handleRestart = async (): Promise<void> => {
    try {
      await restart();
      await navigate({ to: "/app" });
    } catch {
      // isError ja mostra a mensagem abaixo do botao.
    }
  };

  return (
    <section aria-labelledby="restart-onboarding-title" className="flex flex-col gap-3 rounded-xl border border-border bg-card p-5 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0 space-y-1">
        <h2 id="restart-onboarding-title" className="text-sm font-semibold text-foreground">
          Configuração inicial
        </h2>
        <p className="text-xs text-muted-foreground">
          Refaça o passo a passo: empresa, canal, lojas, credenciais e grupos.
        </p>
        {isError && <p role="alert" className="text-xs text-destructive">Não foi possível reabrir agora. Tente de novo.</p>}
      </div>
      <Button type="button" variant="secondary" onClick={() => void handleRestart()} disabled={isPending}>
        {isPending ? <Loader2 size={15} className="animate-spin" aria-hidden="true" /> : <RotateCcw size={15} aria-hidden="true" />}
        Refazer configuração
      </Button>
    </section>
  );
}
